import React, { useEffect, useState } from "react";
import { Loader2, Plus } from "lucide-react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const STATUSES = ["available", "reserved", "in_delivery", "in_rental", "to_return", "maintenance", "unavailable"];
const LABEL = { available: "Disponible", reserved: "Réservé", in_delivery: "En livraison", in_rental: "En location", to_return: "À récupérer", maintenance: "Maintenance", unavailable: "Indisponible" };
const badge = { available: "bg-green-100 text-green-700", reserved: "bg-blue-100 text-blue-700", in_delivery: "bg-amber-100 text-amber-700", in_rental: "bg-brand/10 text-brand", to_return: "bg-orange-100 text-orange-700", maintenance: "bg-slate-200 text-slate-700", unavailable: "bg-red-100 text-red-700" };

const Fleet = () => {
  const [fleet, setFleet] = useState([]);
  const [cities, setCities] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(null);

  const load = () => api.get("/admin/fleet").then((r) => { setFleet(r.data); setLoading(false); });
  useEffect(() => { load(); api.get("/cities").then((r) => setCities(r.data)); api.get("/products").then((r) => setProducts(r.data)); }, []);

  const setStatus = async (id, status) => { await api.patch(`/admin/fleet/${id}`, { status }); load(); };
  const addUnit = async () => {
    if (!form.code) return;
    await api.post("/admin/fleet", form);
    toast.success("Unité ajoutée"); setForm(null); load();
  };

  if (loading) return <div className="grid place-items-center h-64"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-heading font-extrabold text-3xl text-ink">Parc & Stock</h1>
        <Button data-testid="add-unit-btn" onClick={() => setForm({ code: "", product_id: products[0]?.id, city_id: cities[0]?.id, status: "available" })} className="rounded-full h-12 px-6 bg-brand text-white font-bold"><Plus className="w-5 h-5 mr-1" /> Ajouter</Button>
      </div>

      {form && (
        <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm mb-6 grid gap-3 sm:grid-cols-4 items-end">
          <div><label className="text-sm font-semibold">Identifiant</label><input data-testid="unit-code" placeholder="SCOOTER-010" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} className="w-full h-12 rounded-xl border-2 border-slate-200 px-3" /></div>
          <select value={form.product_id} onChange={(e) => setForm({ ...form, product_id: e.target.value })} className="h-12 rounded-xl border-2 border-slate-200 px-3">{products.map((p) => <option key={p.id} value={p.id}>{p.name.fr}</option>)}</select>
          <select value={form.city_id} onChange={(e) => setForm({ ...form, city_id: e.target.value })} className="h-12 rounded-xl border-2 border-slate-200 px-3">{cities.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select>
          <Button onClick={addUnit} data-testid="save-unit-btn" className="h-12 rounded-full bg-accent2 text-white font-bold">Enregistrer</Button>
        </div>
      )}

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
        <table className="w-full text-left min-w-[700px]">
          <thead className="bg-slate-50 text-ink-muted text-sm"><tr><th className="p-4">Identifiant</th><th className="p-4">Matériel</th><th className="p-4">Ville</th><th className="p-4">Statut</th></tr></thead>
          <tbody>
            {fleet.map((u) => (
              <tr key={u.id} className="border-t border-slate-50">
                <td className="p-4 font-semibold text-ink">{u.code}</td>
                <td className="p-4">{u.product_name?.fr || ""}</td>
                <td className="p-4">{u.city_name}</td>
                <td className="p-4"><select value={u.status} onChange={(e) => setStatus(u.id, e.target.value)} className={`rounded-lg px-2 py-1.5 text-sm font-semibold border-0 ${badge[u.status]}`}>{STATUSES.map((s) => <option key={s} value={s}>{LABEL[s]}</option>)}</select></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Fleet;
